import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { ArrowLeftIcon as BackArrowIcon, XCloseIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import { formatTimestamp } from '../EventPane/tabs/TranscriptTab/TranscriptViewer/TranscriptViewer';
import { StyledTranscriptTokens } from '../EventPane/tabs/TranscriptTab/TranscriptViewer/TranscriptViewer.styles';
import {
  StyledMessage,
  StyledSpeaker,
  StyledTimestamp,
  StyledToken,
} from '../EventPane/tabs/TranscriptTab/TranscriptViewer/TranscriptViewer.styles';
import { hideRadioPane } from '../EventPane/tabs/radiosSlice';

const StyledRadioDetails = styled(Box).attrs({
  p: '16px 16px',
  bg: 'transparent',
  color: 'primaryText',
})``;

export const BackButton = styled.button`
  background: transparent;
  padding: 0;
  margin: 0;
  outline: 0;
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  width: 24px;
  height: 24px;
  border-radius: 4px;
  line-height: 0px;
  display: inline-block;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondaryText};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CloseButton = styled.button`
  background: transparent;
  padding: 0;
  margin: 0;
  outline: 0;
  border: 0;
  line-height: 0px;
  display: inline-block;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

export const StyledRadioTranscriptViewer = styled(Box).attrs({
  dataName: 'radio-transcript-viewer',
})`
  background: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  border-radius: 5px;
  flex: 1;
  padding: 16px;
  margin-top: 16px;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
`;

const TranscriptToken = ({ token, selectedTranscript }) => {
  let transcript = token?.transcript;
  if (selectedTranscript === 'translated' && token?.translated) {
    transcript = token?.translated;
  }

  return (
    <StyledMessage>
      <StyledSpeaker
        speakerName={token?.speaker_name}
        data-name="transcript-token-speaker"
      >
        {token?.speaker_display_name}
      </StyledSpeaker>{' '}
      {token?.start_time && (
        <StyledTimestamp>{formatTimestamp(token?.start_time)}</StyledTimestamp>
      )}
      <StyledToken data-name="transcript-token-message">
        "{transcript}"
      </StyledToken>
    </StyledMessage>
  );
};

const RadioTranscriptViewer = ({
  radio = {},
  tokens = [
    {
      token_id: '1',
      speaker_id: '1',
      transcript: 'Control what time did this get called in?',
      speaker_name: 'dispatcher',
      speaker_display_name: 'Speaker',
      start_time: '2021-08-10T15:00:00Z',
    },
    {
      token_id: '2',
      speaker_id: '2',
      transcript: 'Call was created at 14:02.',
      speaker_name: 'caller',
      speaker_display_name: 'Speaker',
      start_time: '2021-08-10T15:00:05Z',
    },
    {
      token_id: '5',
      speaker_id: '1',
      transcript: 'Copy that, thank you.',
      speaker_name: 'dispatcher',
      speaker_display_name: 'Speaker',
      start_time: '2021-08-10T15:00:15Z',
    },
  ],
}) => {
  return (
    <StyledRadioTranscriptViewer>
      <Text fontWeight="bold" size="normal" color="primaryText">
        Radio Transcript
      </Text>
      <Text size="normal" color="secondaryText">
        {radio.name}
      </Text>
      <StyledTranscriptTokens mt="16px">
        {tokens.map(token => (
          <TranscriptToken key={token?.token_id} token={token} />
        ))}
      </StyledTranscriptTokens>
    </StyledRadioTranscriptViewer>
  );
};

const RadioDetails = ({ radio, onBack = () => {} }) => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hideRadioPane());
  };

  return (
    <StyledRadioDetails>
      <Box horizontal justify="space-between">
        <BackButton onClick={onBack}>
          <BackArrowIcon width={14} />
        </BackButton>
        <CloseButton onClick={handleClose}>
          <XCloseIcon />
        </CloseButton>
      </Box>
      <RadioTranscriptViewer radio={radio} />
    </StyledRadioDetails>
  );
};

export default RadioDetails;
